// services/api/tutorService.js
import API from '../api/api';

export const tutorService = {
  getScheduleShift: async () => {
    const response = await API.get('/get_entity_scheduled_shift');
    return response.data.data || [];
  },
  getTutorSessions: async (location_id, semester_id) => {
    const response = await API.get('/get_sessions', {params: { location_id, semester_id}});
    return response.data.data || [];
  },
  getSessionInfo: async (session_id) => {
    const response = await API.get('/get_session_info', {
      params: { session_id }
    });
    return response.data;
  },
  createTutor: async (payload) => {
    const response = await API.post('/create_tutor', payload);
    return response.data;
  },
  
  updateTutor: async (payload) => {
    const response = await API.post('/update_tutor', payload);
    return response.data;
  },
  searchSessions: async (params) => {
    const response = await API.get('/session_search', { params });
    return response.data.data || [];
  },

  requestTutorFile: async (params) => {
    const response = await API.get('/get_tutor_file', { params });
    return response.data;
  },
  
  getTutorFileUrl: async (input_key) => {
    const response = await API.get('/get_tutor_file_url', {
      params: { input_key }
    });
    return response.data;
  },
  
  deleteTutorSession: async (id) => {
    const response = await API.post("/delete_session", {id});
    return response.data;
  },
  getTutors: async (id) => {
    const response = await API.get("/get_tutors", {params: {location_id: id}});
    return response.data.data || []
  },
  getTutorSearch: async (search_term) => {
    const response = await API.get("/tutor_search", {params: {search_term}});
    return response.data.data || []
  },
  deleteTutor: async (id, location_id) => {
    const response = await API.post("/delete_tutor", {id, location_id});
    return response.data;
  }
};


